export const MBR = () => {
  const isMobile = window.innerWidth <= 500;
  return isMobile ? <br /> : null;
};

export const DBR = () => {
  const isMobile = window.innerWidth <= 500;
  return !isMobile ? <br /> : null;
};
